import React, { useState } from 'react';
import { HiOutlineX } from 'react-icons/hi';
import toast from 'react-hot-toast';

const NewsletterPopup = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    toast.success('Thank you for subscribing!');
    setLoading(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white max-w-lg w-full animate-fade-in shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-primary-100 rounded-full transition-colors z-10"
        >
          <HiOutlineX className="w-5 h-5" />
        </button>

        <div className="grid md:grid-cols-2">
          {/* Image */}
          <div className="hidden md:block">
            <img
              src="https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=600"
              alt="Luxury cosmetics"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="p-8 md:p-10 flex flex-col justify-center">
            <h3 className="font-serif text-2xl mb-3">Join Our World</h3>
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Subscribe to receive exclusive offers, early access to new arrivals, and luxury beauty tips.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="w-full border-b border-primary-300 pb-3 focus:outline-none focus:border-luxury-charcoal transition-colors bg-transparent"
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-luxury-charcoal text-white py-3 text-sm uppercase tracking-widest hover:bg-gray-800 transition-colors disabled:opacity-50"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>

            <p className="text-xs text-gray-400 mt-4">
              By subscribing, you agree to receive marketing emails. Unsubscribe anytime.
            </p>

            <button
              onClick={onClose}
              className="mt-4 text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              No thanks, maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterPopup;
